import { createContext } from 'react';

export const SentryContext = createContext<{
  captureException: (error) => void;
}>({
  captureException: () => undefined,
});
